import type {
  AttributesEntity,
  ValuesEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AttributeSelect({
  attribute,
  updateVariantValues,
  className = '',
}: {
  attribute: AttributesEntity;
  updateVariantValues: (attribute: AttributesEntity, value: ValuesEntity) => void;
  className?: string;
}) {
  const attrId = attribute.id;
  const filter = useCategoryStore(state => state.filter.attributes);
  const valueAttribute = filter.find(item => item.id === attrId);
  const selectedValue = valueAttribute?.values[0];
  let value = attribute.values?.find(item => item.id === selectedValue) as ValuesEntity;
  const setFilter = useCategoryStore(state => state.setFilter);

  const sortedValues = [...(attribute.values ?? [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  return (
    <Select
      value={String(selectedValue) ?? ''}
      onValueChange={val => {
        value = attribute.values?.find(item => String(item.id) === String(val)) as ValuesEntity;
        setFilter({ selectedValue: { attribute, value }, replace: true });
        updateVariantValues(attribute, value);
      }}
    >
      <SelectTrigger
        isClearable
        variant="outlined"
        className={cn('ea-attribute-select__trigger')}
        onClear={() => {
          if (!selectedValue) return;
          value = attribute.values?.find(item => item.id === selectedValue) as ValuesEntity;
          setFilter({ selectedValue: { attribute, value: value }, replace: true });
          updateVariantValues(attribute, value);
        }}
      >
        <SelectValue
          placeholder="Choose"
          className={cn('bg-primary', 'ea-attribute-select__trigger-value')}
        />
      </SelectTrigger>
      <SelectContent className={cn('', 'ea-attribute-select__content', className)}>
        {sortedValues.map(value => {
          return (
            <SelectItem
              key={`attribute-${attribute.id}-value-${value.id}`}
              className={cn('', 'ea-attribute-select__item')}
              value={String(value.id)}
            >
              {value.name}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
